import { authHeader } from '@/_helpers'
export const targetsService = {
  verificateTarget,
  getAll,
  getApollo,
  addTarget,
  updatedOrderClosed,
  getTarget,
  getTargetListByClient,
  getTargetListByClientAndStatus,
  updateTarget,
  getContactedOrder,
  getCampaignForOrder,
  getApiKeys,
  getTotalTargetActive,
  addCampaignStep,
  loadCampaingStepTarget,
  getTargetMissingData,
  getActivitiesForOrder,
  updateJobWords,
  getStats,
  addOnboardingFinish,
  updateTargetField,
  getColdCallScript,
  saveColdCallScript,
  insertPriority,
  getTargetApolloDetails,
  getTargetContactSupply,
  getProfitability,
  getTargetListToProfitability,
  calculateDetails,
  getCampaignHealthContactCounts,
  getCampaignHealthTones,
  validateSalesridgeFilters,
  relaunchSalesridgeSearch,
  apolloSearching,
  getLocationsApollo,
  stopThisMonth,
  setUsers,
  getNotProspectingSales,
  getClientAttribution,
  getTargetNotes,
  createTargetNote,
  changeTargetNoteStatus,
  getTargetListNotes,
  getTargetsByClientAndStatus,
  getFinishedTarget,
  editTargetNote,
  getDiagnostic,
  getOrderWarning,
  getOrderSlowingDown,
  unsubscribeContact,
  setNewColdphoning,
  changeContactStatus,
  getDataPhoneByTarget,
  createTasks,
  getTargetImportError,
  getTargetImportProgress,
  getTargetSendEmailProblems,
  getTargetImportProgressRow,
  getTargetSalesridgeImportProgressRow,
  getCriticalSupplyDiagnostic,
  getTargetImportProgressDetail,
  enqueueSalesridgeImportBatches,
  reportImportErrorProblems,
  getPerformanceNotes,
  createPerformanceNote,
  getColdCallTaskByTargets,
  getActivationContacts,
  importActivationContacts,
  deleteActivationContacts,
  enrichActivationContacts,
  exportActivationContacts,
  getActivationContactsStats,
  getActivationImportStatus,
  updateTargetOrderType,
  getOrphanLinks,
  getOrphanLinkCampaignOptions,
  previewOrphanLinkResolve,
  resolveOrphanLink,
  resolveAllOrphanLinks,
  assignCampaignToOrphanLink,
  ignoreOrphanLink,
  getBookingIntake,
  diagnoseBookingIntake,
  recoverBookingIntake,
  getDataColdCallSpecifications,
}

const apiUrl = process.env.VUE_APP_ROOT_API
var lastquery = new Array()
function getAll(client_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ client_id }),
  }
  return fetch(`${apiUrl}/targets/get`, requestOptions).then(handleResponse)
}

function insertPriority(target_id, type) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ target_id, type })
  };
  return fetch(`${apiUrl}/targets/insert-priority`, requestOptions).then(handleResponse);
}

function getOrderWarning(body){
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body:JSON.stringify(body)
  };
  return fetch(`${apiUrl}/targets/get-orders-warning`, requestOptions).then(handleResponse);
}

function calculateDetails(target_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ target_id })
  };
  return fetch(`${apiUrl}/targets/calculate-details`, requestOptions).then(handleResponse);
}

function validateSalesridgeFilters(payload) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify(payload),
  };
  return fetch(`${apiUrl}/targets/validate-salesridge-filters`, requestOptions).then(handleResponse);
}

function getCampaignHealthContactCounts(target_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ target_id }),
  };
  return fetch(`${apiUrl}/targets/campaign-health-contact-counts`, requestOptions).then(handleResponse);
}

function getCampaignHealthTones(target_ids, options = {}) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({
      target_ids,
      import_error_list: !!options.import_error_list,
      skip_remote_salesridge: !!options.skip_remote_salesridge,
    }),
  };
  return fetch(`${apiUrl}/targets/campaign-health-tones`, requestOptions).then(handleResponse);
}

function relaunchSalesridgeSearch(target_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ target_id }),
  };
  return fetch(`${apiUrl}/targets/relaunch-salesridge-search`, requestOptions).then(handleResponse);
}

function getActivitiesForOrder(data, dataItem = 1) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
    //body: JSON.stringify(data),
  }
  const { startDate, endDate, target_ids, last_days, non_admin, client_id } = data;

  return fetch(
    `${apiUrl}/targets/get-activity?client_id=${client_id}&startDate=${startDate}&endDate=${endDate}&data_item=${dataItem}&target_ids=${target_ids}&last_days=${(last_days) ? last_days : 0}&non_admin=${(non_admin) ? non_admin : 0}`,
    requestOptions,
  ).then(handleResponse)
}

function apolloSearching() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(
    `${apiUrl}/targets/apollo-searching`,
    requestOptions,
  ).then(handleResponse)
}


function getTargetApolloDetails(target_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ target_id })
  };
  return fetch(`${apiUrl}/targets/target-apollo-details`, requestOptions).then(handleResponse);
}

function getTargetNotes(targetId){
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }

  return fetch(`${apiUrl}/targets/get-target-note?target_id=${targetId}`, requestOptions)
    .then(handleResponse)
}

function getOrderSlowingDown(targetId){
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/targets/get-target-slowing-down`, requestOptions)
    .then(handleResponse)
}

function getDiagnostic(targetId){
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ targetId })
  }

  return fetch(`${apiUrl}/targets/get-target-diagnostic`, requestOptions)
    .then(handleResponse)
}

function getTargetListNotes(active, count = 0, status = 0) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
    body: JSON.stringify(),
  }

  return fetch(`${apiUrl}/targets/get-target-list-notes?count=${count}&active=${active}&status=${status}`, requestOptions)
    .then(handleResponse)
}

function editTargetNote(target_id, target_note_id, message) {

  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ target_id, target_note_id, message })
  };
  return fetch(
    `${apiUrl}/targets/edit-note`,
    requestOptions,
  ).then(handleResponse)
}

function createTargetNote(target_id, message) {

  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ target_id, message })
  };
  return fetch(
    `${apiUrl}/targets/create-note`,
    requestOptions,
  ).then(handleResponse)
}

function changeTargetNoteStatus(target_id, statusTargetNote) {

  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ target_id, target_note_status_id: statusTargetNote })
  };
  return fetch(
    `${apiUrl}/targets/change-status-note`,
    requestOptions,
  ).then(handleResponse)
}




function getStats(data) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }

  return fetch(`${apiUrl}/targets/get-stats?target_id=${data}`, requestOptions)
    .then(handleResponse)
}

function updatedOrderClosed(data) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ data: { closed: data.closed } }),
  }
  return fetch(
    `${apiUrl}/targets/update-closed/${data.target_id}`,
    requestOptions,
  ).then(handleResponse)
}

function addTarget(data) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ data }),
  }
  return fetch(`${apiUrl}/targets/add-target`, requestOptions).then(
    handleResponse,
  )
}

function updateJobWords(data) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ data }),
  }
  return fetch(`${apiUrl}/targets/update-jobs-words`, requestOptions).then(
    handleResponse,
  )
}

function verificateTarget(data) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ data }),
  }
  return fetch(`${apiUrl}/targets/addVerification`, requestOptions).then(
    handleResponse,
  )
}

function getTarget(target_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ target_id }),
  }
  return fetch(`${apiUrl}/targets/get-target`, requestOptions).then(
    handleResponse,
  )
}

function updateTarget(data) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify(data),
  }
  return fetch(`${apiUrl}/targets/update-target`, requestOptions).then(
    handleResponse,
  )
}

function getContactedOrder(target_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ target_id }),
  }
  return fetch(`${apiUrl}/targets/get-contacted-order`, requestOptions).then(
    handleResponse,
  )
}

function getCampaignForOrder(target_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ target_id }),
  }
  return fetch(`${apiUrl}/targets/get-campaign-order`, requestOptions).then(
    handleResponse,
  )
}

function addOnboardingFinish(target_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ target_id }),
  }
  return fetch(
    `${apiUrl}/targets/onboarding-finish`,
    requestOptions,
  ).then(handleResponse)
}

function getFinishedTarget(count, active,  oliver_sale_id = 0) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ count, oliver_sale_id, active }),
  }
  return fetch(
    `${apiUrl}/targets/get-target-finish`,
    requestOptions,
  ).then(handleResponse)
}

function addCampaignStep(data) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ data }),
  }
  return fetch(
    `${apiUrl}/targets/add-target-campaign-step`,
    requestOptions,
  ).then(handleResponse)
}

function getTargetListByClient(client_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ client_id }),
  }
  return fetch(
    `${apiUrl}/targets/get-target-list-by-client`,
    requestOptions,
  ).then(handleResponse)
}

function getTargetListByClientAndStatus(data) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify(data),
  }
  return fetch(
    `${apiUrl}/targets/get-target-list-by-client`,
    requestOptions,
  ).then(handleResponse)
}

function getTargetsByClientAndStatus(client_id, target_status_ids) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
    body: JSON.stringify(),
  }

  const targetStatusParams = target_status_ids.join(',');

  return fetch(
    `${apiUrl}/targets/get-targets-by-client-and-status?client_id=${client_id}&target_status_id=${targetStatusParams}`,
    requestOptions,
  ).then(handleResponse)
}

function getTargetListToProfitability(active, count = 0, condition = 0, oliver_sale_id = 0, account_executive = 0, year_month = 0) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
    body: JSON.stringify(),
  }
  return fetch(`${apiUrl}/targets/get-target-list-to-profitability?count=${count}&active=${active}&condition=${condition}&oliver_sale_id=${oliver_sale_id}&account_executive=${account_executive}&year_month=${year_month}`, requestOptions)
    .then(handleResponse)
}

function getApollo(data) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ data }),
  }
  return fetch(`${apiUrl}/targets/get-apollo`, requestOptions).then(
    handleResponse,
  )
}

function getLocationsApollo(data) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ data }),
  }
  return fetch(`${apiUrl}/targets/get-apollo-locations`, requestOptions).then(
    handleResponse,
  )
}

function getApiKeys() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/targets/apollo-apis`, requestOptions).then(
    handleResponse,
  )
}

function getTotalTargetActive() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/targets/total-active`, requestOptions).then(
    handleResponse,
  )
}

function loadCampaingStepTarget(data) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify(data),
  }
  return fetch(
    `${apiUrl}/targets/load-campaing-step-target`,
    requestOptions,
  ).then(handleResponse)
}

function getTargetMissingData(active, count = 0) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/targets/target-missing-data?count=${count}&active=${active}`, requestOptions).then(
    handleResponse,
  )
}

function getTargetContactSupply(active, count = 0, oliver_sale_id = 0, status = 1) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/targets/target-contact-supply?count=${count}&active=${active}&oliver_sale_id=${oliver_sale_id}&status=${status}`, requestOptions).then(
    handleResponse,
  )
}

function getProfitability(targetId, completeData = 0) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('applicationi/json'),
  }

  return fetch(`${apiUrl}/targets/get-profitability?target_id=${targetId}&completeData=${completeData}`, requestOptions)
    .then(handleResponse)
}

function stopThisMonth(target_id, hours) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ target_id, hours})
  };
  return fetch(`${apiUrl}/targets/stop-this-month`, requestOptions).then(handleResponse);
}


function setUsers(dataUserTarget){
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ dataUserTarget })
  };

  return fetch(`${apiUrl}/targets/set-users`, requestOptions).then(handleResponse);

}

function getNotProspectingSales(active, count = 0) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/targets/get-not-prospecting-sales?count=${count}&active=${active}`, requestOptions).then(
    handleResponse,
  )
}

function unsubscribeContact(business_contacts_ids, id){
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ business_contacts_ids })
  };

  return fetch(`${apiUrl}/targets/${id}/unsubscribe-contacts`, requestOptions).then(handleResponse);
}

function setNewColdphoning(business_contacts_ids, id, searchFilter = {}, allPages = 0){
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ business_contacts_ids, searchFilter, allPages })
  };

  return fetch(`${apiUrl}/targets/${id}/create-task-cold-phoning`, requestOptions).then(handleResponse);
}


function createTasks(target_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ target_id })
  }
  return fetch(`${apiUrl}/targets/${target_id}/create-tasks`, requestOptions).then(handleResponse)
}

function changeContactStatus(business_contacts_ids, id, business_contact_status_id){
    const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ business_contacts_ids, business_contact_status_id })
  };

  return fetch(`${apiUrl}/targets/${id}/change-contacts-status`, requestOptions).then(handleResponse);
}

function getClientAttribution(active, count = 0) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/targets/get-client-attribution?count=${count}&active=${active}`, requestOptions).then(
    handleResponse,
  )
}


function getTargetImportError(options = false){
    const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  };
  let params = '';
  if (options === true) {
    params = '?count=true';
  } else if (options && options.pipelineOnly === true) {
    params = '?pipeline_only=true';
  }
  return fetch(`${apiUrl}/targets/get-target-import-error${params}`, requestOptions).then(
    handleResponse,
  )
}

function getTargetImportProgress(options = false) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  };
  let params = '';
  if (options === true) {
    params = '?count=true';
  } else if (options && typeof options === 'object') {
    const qs = [];
    if (options.limit != null) {
      qs.push(`limit=${encodeURIComponent(options.limit)}`);
    }
    if (options.offset != null) {
      qs.push(`offset=${encodeURIComponent(options.offset)}`);
    }
    if (options.importStillPending === true) {
      qs.push('import_still_pending=1');
    }
    if (qs.length) {
      params = `?${qs.join('&')}`;
    }
  }
  return fetch(`${apiUrl}/targets/get-target-import-progress${params}`, requestOptions).then(
    handleResponse,
  );
}

function getTargetSendEmailProblems(options = false) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  };
  let params = '';
  if (options === true) {
    params = '?count=true';
  } else if (options && typeof options === 'object') {
    const qs = [];
    if (options.limit != null) {
      qs.push(`limit=${encodeURIComponent(options.limit)}`);
    }
    if (options.offset != null) {
      qs.push(`offset=${encodeURIComponent(options.offset)}`);
    }
    if (qs.length) {
      params = `?${qs.join('&')}`;
    }
  }
  return fetch(`${apiUrl}/targets/get-target-send-email-problems${params}`, requestOptions).then(
    handleResponse,
  );
}

function getTargetImportProgressRow(targetId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  };
  return fetch(
    `${apiUrl}/targets/get-target-import-progress-row?target_id=${encodeURIComponent(targetId)}`,
    requestOptions,
  ).then(handleResponse);
}

function getTargetSalesridgeImportProgressRow(targetId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  };
  return fetch(
    `${apiUrl}/targets/get-target-salesridge-import-progress-row?target_id=${encodeURIComponent(targetId)}`,
    requestOptions,
  ).then(handleResponse);
}

function getCriticalSupplyDiagnostic(targetId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  };
  return fetch(
    `${apiUrl}/targets/get-critical-supply-diagnostic?target_id=${encodeURIComponent(targetId)}`,
    requestOptions,
  ).then(handleResponse);
}

function getTargetImportProgressDetail(targetId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  };
  return fetch(
    `${apiUrl}/targets/get-target-import-progress-detail?target_id=${encodeURIComponent(targetId)}`,
    requestOptions,
  ).then(handleResponse);
}

function enqueueSalesridgeImportBatches(targetId, fetchLimit = null) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({
      target_id: targetId,
      fetch_limit: fetchLimit,
    }),
  };
  return fetch(`${apiUrl}/targets/enqueue-salesridge-import-batches`, requestOptions).then(
    handleResponse,
  );
}

function reportImportErrorProblems() {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({}),
  };
  return fetch(`${apiUrl}/targets/report-import-error-problems`, requestOptions).then(
    handleResponse,
  );
}

function getDataPhoneByTarget(target_id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/targets/data-phone-by-target/${target_id}`, requestOptions).then(handleResponse)
}

function getPerformanceNotes(targetId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/target-com-notes/?target_id=${targetId}`, requestOptions).then(handleResponse)
}

function createPerformanceNote(targetId, message) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ target_id: targetId, message }),
  }
  return fetch(`${apiUrl}/target-com-notes/`, requestOptions).then(handleResponse)
}

function getColdCallTaskByTargets(target_ids) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ target_ids }),
  }
  return fetch(`${apiUrl}/targets/get-cold-call-task-by-targets`, requestOptions).then(handleResponse)
}

function getActivationContacts(targetId, params = {}) {
  const query = new URLSearchParams({
    currentPage: params.currentPage || 1,
    cantPerPage: params.cantPerPage || 25,
    searchFilter: params.search || '',
    getTotal: params.getTotal != null ? params.getTotal : 0,
  })
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(
    `${apiUrl}/targets/${targetId}/activation-contacts?${query.toString()}`,
    requestOptions,
  ).then(handleResponse)
}

function importActivationContacts(targetId, payload) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify(payload),
  }
  return fetch(
    `${apiUrl}/targets/${targetId}/activation-contacts/import`,
    requestOptions,
  ).then(handleResponse)
}

function deleteActivationContacts(targetId, payload) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify(payload),
  }
  return fetch(
    `${apiUrl}/targets/${targetId}/activation-contacts/delete`,
    requestOptions,
  ).then(handleResponse)
}

function enrichActivationContacts(targetId, payload) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify(payload),
  }
  return fetch(
    `${apiUrl}/targets/${targetId}/activation-contacts/enrich`,
    requestOptions,
  ).then(handleResponse)
}

function exportActivationContacts(targetId, payload) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify(payload),
  }
  return fetch(
    `${apiUrl}/targets/${targetId}/activation-contacts/export`,
    requestOptions,
  ).then(handleResponse)
}

function getActivationContactsStats(targetId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(
    `${apiUrl}/targets/${targetId}/activation-contacts/stats`,
    requestOptions,
  ).then(handleResponse)
}

function getActivationImportStatus(targetId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(
    `${apiUrl}/targets/${targetId}/activation-import-status`,
    requestOptions,
  ).then(handleResponse)
}

function updateTargetOrderType(targetId, orderType) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ order_type: orderType }),
  }
  return fetch(
    `${apiUrl}/targets/${targetId}/order-type`,
    requestOptions,
  ).then(handleResponse)
}

function getOrphanLinks(params = {}) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  const query = new URLSearchParams()
  if (params.unbilled_only) query.set('unbilled_only', '1')
  if (params.past_only) query.set('past_only', '1')
  if (params.client_id) query.set('client_id', params.client_id)
  const qs = query.toString()
  return fetch(
    `${apiUrl}/targets/get-orphan-links${qs ? `?${qs}` : ''}`,
    requestOptions,
  ).then(handleResponse)
}

function getBookingIntake(params = {}) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  const query = new URLSearchParams()
  if (params.status) query.set('status', params.status)
  if (params.source && params.source !== 'all') query.set('source', params.source)
  if (params.client_id) query.set('client_id', params.client_id)
  if (params.q) query.set('q', params.q)
  if (params.limit) query.set('limit', params.limit)
  const qs = query.toString()
  return fetch(
    `${apiUrl}/targets/get-booking-intake${qs ? `?${qs}` : ''}`,
    requestOptions,
  ).then(handleResponse)
}

function diagnoseBookingIntake(id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(
    `${apiUrl}/targets/booking-intake/${id}/diagnose`,
    requestOptions,
  ).then(handleResponse)
}

function recoverBookingIntake(id, action, targetLinkId = null) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({
      action,
      target_link_id: targetLinkId || null,
    }),
  }
  return fetch(
    `${apiUrl}/targets/booking-intake/${id}/recover`,
    requestOptions,
  ).then(handleResponse)
}

function getOrphanLinkCampaignOptions(linkId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(
    `${apiUrl}/targets/orphan-links/${linkId}/campaign-options`,
    requestOptions,
  ).then(handleResponse)
}

function resolveAllOrphanLinks(params = {}) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({
      unbilled_only: params.unbilled_only ? 1 : 0,
      past_only: params.past_only ? 1 : 0,
      client_id: params.client_id || null,
    }),
  }
  return fetch(
    `${apiUrl}/targets/resolve-orphan-links`,
    requestOptions,
  ).then(handleResponse)
}

function previewOrphanLinkResolve(linkId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(
    `${apiUrl}/targets/orphan-links/${linkId}/resolve-preview`,
    requestOptions,
  ).then(handleResponse)
}

function resolveOrphanLink(linkId) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({}),
  }
  return fetch(
    `${apiUrl}/targets/orphan-links/${linkId}/resolve`,
    requestOptions,
  ).then(handleResponse)
}

function assignCampaignToOrphanLink(linkId, campaignId) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ campaign_id: campaignId }),
  }
  return fetch(
    `${apiUrl}/targets/orphan-links/${linkId}/assign-campaign`,
    requestOptions,
  ).then(handleResponse)
}

function ignoreOrphanLink(linkId, reason = null) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ reason }),
  }
  return fetch(
    `${apiUrl}/targets/orphan-links/${linkId}/ignore`,
    requestOptions,
  ).then(handleResponse)
}

function updateTargetField(target_id, field, value) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ field, value }),
  }
  return fetch(
    `${apiUrl}/targets/${encodeURIComponent(target_id)}/update-field`,
    requestOptions,
  ).then(handleResponse)
}

function getColdCallScript(target_id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(
    `${apiUrl}/targets/${encodeURIComponent(target_id)}/cold-call-script`,
    requestOptions,
  ).then(handleResponse)
}

function saveColdCallScript(target_id, data) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify(data),
  }
  return fetch(
    `${apiUrl}/targets/${encodeURIComponent(target_id)}/cold-call-script`,
    requestOptions,
  ).then(handleResponse)
}

function getDataColdCallSpecifications(target_id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(
    `${apiUrl}/targets/get-data-cold-call-specifications?target_id=${encodeURIComponent(target_id)}`,
    requestOptions,
  ).then(handleResponse)
}

function rejectHttpError(response, data, fallbackMessage) {
  const status = response && response.status
  let message =
    fallbackMessage ||
    (response && response.statusText) ||
    'Request failed'
  if (typeof data === 'string' && data) {
    message = data
    return Promise.reject({ message, status })
  }
  if (data && typeof data === 'object' && !Array.isArray(data)) {
    message = data.message || data.error || message
    return Promise.reject(Object.assign({}, data, { message, status }))
  }
  return Promise.reject({ message, status })
}

function handleResponse(response) {
  return response.text().then((text) => {
    let data = null
    if (text) {
      try {
        data = JSON.parse(text)
      } catch (err) {
        // Local PHP display_errors / notices sometimes prepend garbage to JSON.
        const start = text.indexOf('{')
        const end = text.lastIndexOf('}')
        if (start !== -1 && end > start) {
          try {
            data = JSON.parse(text.slice(start, end + 1))
          } catch (err2) {
            return rejectHttpError(
              response,
              null,
              (err && err.message) || 'Invalid JSON response from API',
            )
          }
        } else {
          return rejectHttpError(
            response,
            null,
            (err && err.message) || 'Invalid JSON response from API',
          )
        }
      }
    }
    if (!response.ok) {
      return rejectHttpError(response, data, response.statusText)
    }
    return data
  })
}
